import { cn } from '@dfh-corp-sites/ui/utils'
import { useLocation } from '@gatsbyjs/reach-router'
import React, { FC, useMemo } from 'react'

import { setActiveItem } from '../../../lib/header/state'
import Link from '../Link'

type MagentoCategory = Array<{
  __typename?: 'FacetedResultsAggregationOption'
  label?: string | null
  value: string
  count?: number | null
}> | null

type SanityCategory =
  | Array<{
      __typename?: 'SanityProductCategory'
      title?: string | null
      isActive?: boolean | null
    } | null>
  | null
  | undefined

interface CategoriesListProps {
  categories?: MagentoCategory | SanityCategory | null
}

export const CategoriesList: FC<CategoriesListProps> = ({ categories }) => {
  const location = useLocation()

  const renderedCategories = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    const currentCategory = searchParams.get('category') || ''
    const isProductsPage = location.pathname === '/products' || location.pathname === '/products/'

    return categories?.reduce((acc, item) => {
      if (!item) return acc

      const value = 'value' in item ? item.value : 'title' in item ? item.title : null
      if (!value) return acc

      const isSelected = isProductsPage && currentCategory === value
      const encodedValue = encodeURIComponent(value)

      acc.push(
        <Link
          key={value}
          to={`/products?category=${encodedValue}`}
          className={cn('text-lg font-normal hover:font-medium', { 'font-medium': isSelected })}
          onClick={() => setActiveItem(null)}
        >
          {value}
        </Link>,
      )

      return acc
    }, [] as React.ReactNode[])
  }, [categories, location.search, location.pathname])

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-2">
      {renderedCategories}
    </div>
  )
}
